import React from "react";
// hooks
import { useStyles } from "../hooks/useStyles";
// UI
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
// language
import { useLocale } from "../../../modules/hooks/UseLocale";

interface HeadCell {
  id: string;
  label: string;
}

const headCells: HeadCell[] = [
  {
    id: "DateTime",
    label: "created_date",
  },
  {
    id: "UpdatedBy",
    label: "created_by",
  },
  {
    id: "Description",
    label: "description",
  },
];

export const JobsDetailGeneralRepairMediaThead = (props: any) => {
  const classes = useStyles();
  const { t } = useLocale({
    defaultPath:
      "modules.components.jobDetail.general.group_repair_updated_history",
  });
  return (
    <TableHead className={classes.thead}>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell key={headCell.id}>{t(headCell.label)}</TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
